import { EndPoints, PersonStatus } from '../../common/enums/enums';
import { api } from './api';

const buildQueryBody = (page, levels, searchQuery) => ({
  pageNumber: page,
  pageSize: 20,
  order: 'asc',
  filters: [],
  searchQuery,
  groupedFilters: {
    AND: [
      {
        OR: levels.map(level => ({
          column: 'companyId',
          value: level,
          operator: 'eq',
        })),
      },
      {
        OR: [
          {
            column: 'status',
            value: PersonStatus.ACTIVE,
            operator: 'eq',
          },
          {
            column: 'status',
            value: PersonStatus.PENDING,
            operator: 'eq',
          },
        ],
      },
    ],
  },
});

export const usersServices = api.injectEndpoints({
  endpoints: build => ({
    getUsers: build.query({
      query: ({ page, level, searchQuery }) => ({
        url: EndPoints.USERS.GET_USERS,
        method: 'POST',
        body: buildQueryBody(page, level, searchQuery),
      }),
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        return `${endpointName}(${queryArgs.level.toString()}, "${
          queryArgs.searchQuery
        }")`;
      },
      forceRefetch({ currentArg, previousArg }) {
        if (!previousArg) return true;
        return (
          currentArg.companyId !== previousArg.companyId ||
          currentArg.page > previousArg.page ||
          currentArg.level.toString() !== previousArg.level.toString() ||
          currentArg.searchQuery !== previousArg.searchQuery
        );
      },
      merge: (currentData, responseData) => {
        currentData.pagination = responseData.pagination;
        currentData.users.push(...responseData.users);
      },
    }),
    inviteUser: build.mutation({
      query: newUser => ({
        url: EndPoints.USERS.INVITE_USER,
        method: 'POST',
        body: newUser,
      }),
    }),
    editUser: build.mutation({
      query: user => ({
        url: `${EndPoints.USERS.UPDATE_USER}/${user.personId}`,
        method: 'PATCH',
        body: user.data,
      }),
    }),
    resendInvitation: build.mutation({
      query: user => ({
        url: EndPoints.USERS.RESEND_INVITATION.replace(
          '{userId}',
          user.personId
        ),
        method: 'POST',
      }),
    }),
    deleteUser: build.mutation({
      query: user => ({
        url: EndPoints.USERS.DELETE_USER.replace('{userId}', user.personId),
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetUsersQuery,
  useEditUserMutation,
  useInviteUserMutation,
  useResendInvitationMutation,
  useDeleteUserMutation,
} = usersServices;
